<template>
  <div class="flex flex_gap_10">
    <div v-if="shiftMessage">
      <template v-if="shiftMessage.message_type === 'timeRemain'">
        <VueCountdown :time="shiftMessage.value * 60 * 1000">
          <template slot-scope="props">Окончание смены через： <span class="badge badge-info">{{ props.minutes }}</span>
            мин.
          </template>
        </VueCountdown>
      </template>
      <template v-if="shiftMessage.message_type === 'shiftOverdue'">
        <div class="flex flex_gap_10 close_shift_message border">
          <div class="flex badge badge-warning align-items-center no_shifts">
            <i class="icon-fa icon-fa-info fs-18"/>
          </div>
          <div>
            <p>Ваша смена закончена</p>
            <p>будет закрыта автоматически в течении 15-ти минут</p>
          </div>
        </div>
      </template>
    </div>
    <template v-if="!$myShift">
      <template v-if="!$AllowedShifts || !$AllowedShifts.length">
        <div class="flex flex_gap_10">
          <div>
            <p>нет активных смен для Вас</p>
          </div>
          <div class="flex badge badge-warning align-items-center no_shifts">
            <i class="icon-fa icon-fa-info fs-18"/>
          </div>
        </div>
      </template>
      <template v-else>
        <!--          :delay="{ show: 100, hide:500 }"-->
        <v-popover
          class=""
          trigger="click"
          :open="openPopover"
          popoverClass="list_work_shift_activation_popover"
          popoverInnerClass="popover_content"
          :auto-hide="false">
          <div class="no_shift_icon_block badge badge-warning">
            <i class="icon-fa icon-fa-info"></i>
          </div>
          <template slot="popover">
            <div class="">
              <template v-if="$UserIsFreeToday">
                <p>По графику Вы сегодня не работаете</p>
                <p>Желаете активировать смену или выбрать менеджера для подмены?</p>
                <hr>
                <p>Выберите кого хотите подменить</p>
                <div class="mb-1">
                  <Multiselect v-model="userToShift" :options="usersToShift"
                               placeholder="Выберите менеджера"
                               label="name"
                               track-by="name">
                  </Multiselect>
                </div>
              </template>
              <template v-else>
                <p>Выберите смену</p>
              </template>
              <div class="flex flex_gap_10">
                <div>
                  <div v-for="shift in $AllowedShifts" class="mb-1">
                    <LoadingButton
                      :title="shift?.title + ` (${printTime(shift?.start, 'HH:mm')} - ${printTime(shift?.end, 'HH:mm')})`"
                      className="btn btn-default"
                      :loading="loading"
                      color="#02a2f8"
                      :onClick="() => activateShift(shift)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </v-popover>
      </template>
    </template>
    <template v-else>
      <div class="flex flex_gap_10">
        <div class="fs-12">
          <p><strong>{{ $ActiveWorkGroup?.group?.title }}</strong></p>
          <template v-if="($ActiveWorkGroup?.group?.data?.projects ?? []).length">
            <p><span
              v-for="(p, i) in $ActiveWorkGroup.group.data.projects">{{ i !== 0 ? ', ' : '' }}{{
                $AllProjects[p]?.title
              }}</span>
            </p>
          </template>
          <template v-else>
            <p>все проекты</p>
          </template>
          <p>{{ $myShift?.shift?.title }} ({{ $myShift?.shift?.id }})</p>
        </div>
        <v-popover
          class=""
          :delay="{ show: 100, hide: 500 }"
          popoverClass="work_shift_activation_popover"
          popoverInnerClass="popover_content"
          trigger="hover"
          :auto-hide="true">
          <div class="popover_icon">
            <i class="icon-fa icon-fa-info"></i>
          </div>
          <template slot="popover">
            <div class="">
              <p>Активировна с: <strong>{{ printDate(activeShift.created_at, 'HH:mm') }}</strong></p>
              <p><strong>{{ $myShift?.shift?.title }} ({{ $myShift?.shift?.id }})</strong></p>
              <p v-if="$myShift?.shift">{{ printTime($myShift?.shift?.start) }} - {{
                  printTime($myShift?.shift?.end)
                }}</p>
              <p>Мои доступы</p>
              <div>
                <p v-for="(access, project) in $orderAccess">
                  <strong>{{
                      project === 'all' ? 'Все проекты' : $AllProjects[project] && $AllProjects[project].name || 'Не определен'
                    }}</strong>:
                  {{
                    access.all ? 'Все направления' : $AllCities[Object.keys(access)[0]] && $AllCities[Object.keys(access)[0]].name || 'не определен'
                  }}
                </p>
              </div>
              <p>Активные <strong>SIP</strong></p>
              <hr>
              <div>
                <div v-for="(sip) in $PhoneNumbers.sipAccounts" class="flex flex_gap_10 justify-content-between mb-1">
                  <p>{{ printSip(sip.sip_login) }}</p>
                  <div class="flex">
                    <button @click="copyToBuffer(sip.sip_login, true)"
                            class="btn btn-outline-info btn-xs mr-1"
                            type="button"
                    ><i class="icon-fa icon-fa-copy"/> SIP
                    </button>
                    <button @click="copyToBuffer(sip.sip_password)"
                            class="btn btn-outline-info btn-xs"
                            type="button"
                    ><i class="icon-fa icon-fa-copy"/> пароль
                    </button>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button @click="closeShift" class="btn btn-outline-warning">Закрыть смену</button>
              </div>
            </div>
          </template>
        </v-popover>
      </div>

    </template>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import store from "@/store";
import Multiselect from 'vue-multiselect'
import VueCountdown from '@chenfengyuan/vue-countdown';

export default {
  components: {LoadingButton, Multiselect, VueCountdown},
  data() {
    return {
      openPopover: true,
      loading: false,
      shiftMessage: null,
      userToShift: null,
      usersToShift: [],
      activeShift: null,
    }
  },
  computed: {
    $AllProjects() {
      return this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
    },
    $AllCities() {
      return this.$store.getters["platform/cities"];
    },
    $PhoneNumbers() {
      return this.$store.getters["user/phoneNumbers"];
    },
    $UserIsFreeToday() {
      return this.$store.getters["user/isFreeToday"];
    },
    $AllowedShifts() {
      return this.$store.getters["user/allowedShifts"];
    },
    $myShift() {
      return this.$store.getters["user/myShift"];
    },
    $ActiveWorkGroups() {
      return this.$store.getters["user/activeWorkGroups"];
    },
    $ActiveWorkGroup() {
      return this.$store.getters["user/activeWorkGroup"];
    }
  },

  created() {
    this.activeShift = {...(this.$ActiveWorkGroup ?? {})};
    if (this.$UserIsFreeToday) {
      this.getUsersToShift();
    }
    this.$socket.client.on('personal_user_' + this.$currentUID, (payload) => {
      switch (payload?.type) {
        case 'closeWorkingShift':
          // this.closeShift();
          break;
        case 'workingShiftMessage':
          this.shiftMessage = payload;
          break;
        case 'setWorkingShift':
          if (payload?.shift) {
            this.activeShift = payload.shift
          } else {
            this.activeShift = null;
          }
          break;
      }
    })
  },
  methods: {
    printSip(sip) {
      return sip.split('sip:')[1];
    },
    async getUsersToShift() {
      const {data} = await api.index('/new/users/managers/list');
      if (data.success) {
        this.usersToShift = data.records;
      }
    },
    printTime(time) {
      const t = time.split(':');
      return t[0] + ':' + t[1];
    },
    updateShifts() {

    },
    async closeShift() {
      const {data} = await api.index('users/updateShift/' + this.$myShift.id + '?action=deactivate');
      if (data.success) {
        toastr["success"]("Смена закрыта");
        // store.dispatch('user/setActiveWorkGroup', null)
        store.dispatch('user/setMyShift', null)
        this.activeShift = null;
      }
    },
    async activateShift(shift) {
      if (this.loading) return;
      this.loading = true;
      const {data} = await api.post('/users/activateShift', {
        group: shift.group_id,
        work_shift_id: shift.work_shift_id,
        shift_history_id: shift.work_shift_history_id,
        is_free: this.$UserIsFreeToday,
        shift_user: this.userToShift?.id ?? null
      });
      if (data.success) {
        // this.openPopover = false;

      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading = false;
    },
    copyToBuffer(id, login = false) {
      const el = document.createElement('textarea');
      if (login) {
        id = id.split('sip:')[1];
      }
      el.value = id;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      // const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      toastr['success']('Скопированно!')
    },
  }
}

</script>

<style>
.tooltip.popover.work_shift_activation_popover {
  z-index: 9999 !important;
  min-width: 450px;
}

.tooltip.popover.list_work_shift_activation_popover {
  min-width: 450px;
  margin-top: 20px;
}

</style>

<style scoped>
.no_shifts {
  padding: 1px 14px;
}

p {
  margin-bottom: 0;
}

.popover_icon i {
  font-size: 21px;
  vertical-align: middle;
}

.popover_icon {
  margin-top: 2px;
  background-color: #02a2f8;
  padding: 5px 13px;
  border-radius: 7px;
  color: white;
  cursor: pointer;
}

.no_shift_icon_block {
  height: 30px;
  width: 30px;
  font-size: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 4px;
  cursor: pointer;
}

.no_shift_icon_block .icon-fa {
  margin: 0 auto;
}

.title {
  font-size: 10px;
  margin-bottom: 0;
}

.close_shift_message {
  padding: 4px;
  font-size: 10px;
  margin-right: 10px;
}

</style>
